/**
 * @file wrapper-text-field.component.tsx
 * @description Обертка для текстового поля с переключаемыми режимами редактирования для Task Manager приложения, которая обеспечивает inline-редактирование содержимого ячеек таблицы. Автоматически переключается между режимом отображения (Text) и режимом редактирования (TextField) в зависимости от фокуса и наличия значения, поддерживает отображение как простых строк так и объектов со свойством name, интегрируется с утилитой getDefaultCell для стандартизированного отображения ячеек.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['react', '@consta/uikit/TextField', '@components/ui/base/text', '@utils/table-view']
 * @related-files ['src/utils/table-view.ts', 'src/components/ui/text.tsx', 'src/features/table/table.component.tsx']
 */

import { useState, ComponentProps } from 'react';
import { TextField } from '@consta/uikit/TextField';
import { Text } from '@components/ui/base/text';
import { getDefaultCell } from '@utils/table-view';

/**
 * Props для компонента WrapperTextField (переключаемого текстового поля)
 */
interface IWrapperTextFieldProps extends Omit<ComponentProps<typeof TextField>, 'value' | 'onChange'> {
    /** Значение поля (может быть строкой или объектом с полем name) */
    value?: string | { name: string } | null;
    /** Callback функция вызываемая при изменении значения */
    onChange?: (value: string | { name: string } | null) => void;
}

export const WrapperTextField = ({ value, ...props }: IWrapperTextFieldProps) => {
    const [isFocus, setIsFocus] = useState(!value);

    if (isFocus || !value) {
        return (
            <TextField
                {...props}
                value={typeof value === 'object' && value !== null && 'name' in value ? value.name : String(value || '')}
                onFocus={() => setIsFocus(true)}
                onBlur={() => setIsFocus(false)}
                autoFocus={true}
            />
        );
    }

    return (
        <Text onClick={() => setIsFocus(true)}>
            {getDefaultCell(value)}
        </Text>
    );
};